/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: index.ts
 * Class: index.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import Vue from 'vue';
import { computed, ComputedRef } from '@vue/composition-api';

export interface BreakpointStateTypes {
  width: number;
}

export class BreakpointPlugin {
  public state: BreakpointStateTypes;

  constructor() {
    this.state = Vue.observable({
      width: window.innerWidth,
    });

    window.addEventListener('resize', () => {
      this.state.width = window.innerWidth;
    });
  }

  get isExtraSmallSize(): ComputedRef<boolean> {
    return computed<boolean>(
      () => this.state.width < Number(process.env.VUE_APP_BREAKPOINT_SM_NUMERIC),
    );
  }

  get isSmallSize(): ComputedRef<boolean> {
    return computed<boolean>(() => (
      this.state.width >= Number(process.env.VUE_APP_BREAKPOINT_SM_NUMERIC)
        && this.state.width < Number(process.env.VUE_APP_BREAKPOINT_MD_NUMERIC)
    ));
  }

  get isMediumSize(): ComputedRef<boolean> {
    return computed<boolean>(() => (
      this.state.width >= Number(process.env.VUE_APP_BREAKPOINT_MD_NUMERIC)
      && this.state.width < Number(process.env.VUE_APP_BREAKPOINT_LG_NUMERIC)
    ));
  }

  get isLargeSize(): ComputedRef<boolean> {
    return computed<boolean>(() => (
      this.state.width >= Number(process.env.VUE_APP_BREAKPOINT_LG_NUMERIC)
        && this.state.width < Number(process.env.VUE_APP_BREAKPOINT_XL_NUMERIC)
    ));
  }

  get isExtraLargeSize(): ComputedRef<boolean> {
    return computed<boolean>(() => (
      this.state.width >= Number(process.env.VUE_APP_BREAKPOINT_XL_NUMERIC)
    ));
  }

  get mediaExtraSmallSize(): string {
    return process.env.VUE_APP_BREAKPOINT_XS;
  }

  get mediaSmallSize(): string {
    return process.env.VUE_APP_BREAKPOINT_SM;
  }

  get mediaMediumSize(): string {
    return process.env.VUE_APP_BREAKPOINT_MD;
  }

  get mediaLargeSize(): string {
    return process.env.VUE_APP_BREAKPOINT_LG;
  }

  get mediaExtraLargeSize(): string {
    return process.env.VUE_APP_BREAKPOINT_XL;
  }
}

export function VueBreakpointPlugin(vue: typeof Vue, options?): void {
  Vue.prototype.$breakpoint = new BreakpointPlugin();
}

// ### Composition API Usage ###
export const breakpoint = new BreakpointPlugin();
export const useBreakpoint = () => breakpoint;
